// extracted by mini-css-extract-plugin
export default {"map-icon":"MapIcon_map-icon__10P6u"};